import React from 'react';
import LoadingImg from '../../assets/images/loading.gif';
import './style.scss';

const Loading = () => <span className="loading"><img className="loading-img" src={LoadingImg} alt="Trung tâm phát triển năng lực" /></span>;

export default Loading;
